import React from 'react';
import HostRoomScreen from '../../components/HostRoomScreen';

const RapHousieRoomType = () => <HostRoomScreen gameId="rap_housie" />;

export default RapHousieRoomType;
